import React, { useState, useEffect } from 'react';

import 'react-toastify/dist/ReactToastify.css';

import { useNavigate } from 'react-router-dom';
import { useDispatch } from 'react-redux';
import { toast } from 'react-toastify';
import { get } from 'lodash';
import { InputText } from 'primereact/inputtext';
import { InputNumber } from 'primereact/inputnumber';

import * as actions from '../../../store/modules/auth/actions';

import { displayErrors } from '../../../util/diversos';
import { Input100px, Input155px } from '../../../styles/inputGroup';

import Card from '../../../components/card';
import store from '../../../store/store';
import axiosAdmin from '../../../services/axiosAdmin';
import Loading from '../../loading';

export default function CadastroOfxLayoutNumero({ payloadCadastro, childToParentConsulta }) {
  const navigate = useNavigate();
  const dispatch = useDispatch();

  const id = get(payloadCadastro, 'id', 0);

  const [codigoBanco, setCodigoBanco] = useState('');
  const [descricao, setDescricao] = useState('');
  const [numeroCaracteres, setNumeroCaracteres] = useState(0);

  const [isLoading, setIsLoading] = useState(false);

  useEffect(() => {
    let newTitle = 'Layout do Número OFX - Cadastro';
    if (id) {
      newTitle = 'Layout do Número OFX - Edição';
    }

    dispatch(actions.titleHeaderChange({ newTitle }));

    if (!id) return;

    async function getData() {
      try {
        setIsLoading(true);

        const { data } = await axiosAdmin.get(`/ofxlayoutnumero/${id}`);

        const idUsuario = get(store.getState().auth.user, 'id', 0);
        if (data.idUsuario !== idUsuario) {
          navigate('/consultaofxlayoutnumero');
          toast.error('Acesso negado');
        }

        setCodigoBanco(data.codigoBanco);
        setDescricao(data.descricao);
        setNumeroCaracteres(data.numeroCaracteres);
      } catch (err) {
        displayErrors(err, dispatch, navigate, '/', '');
      } finally {
        setIsLoading(false);
      }
    }

    getData();
  }, [dispatch, id, navigate]);

  async function salvarRegistro() {
    try {
      setIsLoading(true);

      const idUsuario = get(store.getState().auth.user, 'id', 0);

      let payloadDataTableList = {};

      const shippingData = {
        idUsuario,
        codigoBanco,
        descricao,
        numeroCaracteres,
      };

      if (id > 0) {
        payloadDataTableList = get(await axiosAdmin.put(`/ofxlayoutnumero/${id}`, shippingData), 'data', {});
        toast.success('Layout do Número OFX atualizado com sucesso');
      } else {
        payloadDataTableList = get(await axiosAdmin.post('/ofxlayoutnumero', shippingData), 'data', {});
        toast.success('Layout do Número OFX cadastrado com sucesso');
      }

      childToParentConsulta(payloadDataTableList, id);
    } catch (err) {
      displayErrors(err, dispatch, navigate, '', 'Não foi possível atualizar o registro');
    } finally {
      setIsLoading(false);
    }
  }

  const handleCancel = () => {
    childToParentConsulta();
  };

  const handleSubmit = (e) => {
    e.preventDefault();

    let formErros = false;

    if (codigoBanco.length !== 3) {
      formErros = true;
      toast.error('Código do Banco deve ter 3 números');
    }
    if (!descricao) {
      formErros = true;
      toast.error('Descrição deve ser informada');
    }
    if (numeroCaracteres <= 0) {
      formErros = true;
      toast.error('Número de Caracteres deve ser informado');
    }

    if (formErros) return;

    salvarRegistro();
  };

  const titulo = () => (id ? 'Layout do Número OFX - Alteração' : 'Layout do Número OFX - Inclusão');

  function botoesFinalizar() {
    return (
      <div className="card-header" style={{ marginLeft: '12px', marginRight: '12px', width: '98%' }}>
        <div className="row">
          <div className="col-lg-9">
            <div style={{ display: 'flex', justifyContent: 'start', position: 'relative', top: '20%' }}>
              <h6>{titulo()}</h6>
            </div>
          </div>
          <div className="col-lg-3">
            <div style={{ display: 'flex', justifyContent: 'end', alignItems: 'center' }}>
              <button
                onClick={handleSubmit}
                type="button"
                className="btn btn-success"
              >
                <i className="pi pi-check"></i>
                Salvar
              </button>
              <button
                onClick={handleCancel}
                type="button"
                className="btn btn-danger"
              >
                <i className="pi pi-times"></i>
                Cancelar
              </button>
            </div>
          </div>
        </div>
      </div>
    );
  }

  return (
    <div>
      <Loading isLoading={isLoading} />
      <Card style={{ marginTop: '16px' }}>
        <div className="row form-elo">
          { botoesFinalizar() }
        </div>
        <div className="row form-elo">
          <div className="col-6">
            <div className="p-inputgroup">
              <Input155px className="p-inputgroup-addon">
                Código Banco
              </Input155px>
              <InputText
                autoFocus
                maxLength={3}
                value={codigoBanco}
                onChange={e => setCodigoBanco(e.target.value)}
              />
            </div>
          </div>
          <div className="col-6">
            <div className="p-inputgroup">
              <Input155px className="p-inputgroup-addon">
                Nº Caracteres
              </Input155px>
              <InputNumber
                min={0}
                max={9999}
                value={numeroCaracteres}
                onValueChange={e => setNumeroCaracteres(e.target.value)}
              />
            </div>
          </div>
        </div>
        <div className="row form-elo">
          <div className="col-12">
            <div className="p-inputgroup">
              <Input100px className="p-inputgroup-addon">
                Descrição
              </Input100px>
              <InputText
                maxLength={100}
                value={descricao}
                onChange={e => setDescricao(e.target.value)}
              />
            </div>
          </div>
        </div>
      </Card>
    </div>
  );
}
